const REQUEST_TYPES = {
	YEARS: 'years',
	MAKES: 'makes',
	MODELS: 'models',
};

const baseRequestPath = '/ajax/vehicle-picker';

const vpRequest = ({type, method='POST', data={}, error, success}) => {
	const validRequestTypes = Object.values(REQUEST_TYPES);
	if (!validRequestTypes.includes(type)) {
		return new Error(`Invalid request type. One of ${validRequestTypes.join(', ')} expected.`);
	}

	return () => {
		return $ajax({
			method,
			dataType: 'json',
			data,
			url: `${baseRequestPath}/${type}`,
			error,
			success,
		});
	};
};

const fetchYears = ({make, model}, success, error) => {
	return vpRequest({
		type: REQUEST_TYPES.YEARS,
		data: {
			make,
			model,
		},
		success,
		error,
	});
};

const fetchMakes = ({year, model}, success, error) => {
	return vpRequest({
		type: REQUEST_TYPES.MAKES,
		data: {
			year,
			model,
		},
		success,
		error,
	});
};

const fetchModels = ({make, year}, success, error) => {
	return vpRequest({
		type: REQUEST_TYPES.MODELS,
		data: {
			make,
			year,
		},
		success,
		error,
	});
};

const fetchYmmFilters = ({year, make, model}) => {
	return new Promise((resolve, reject) => {
		let requests = 0;
		const results = {};
		const errors = {};

		function check() {
			if (requests <= 0) {
				resolve({data: results, errors});
			}
		}

		function success(name) {
			return (data) => {
				results[name] = {...data};
				requests -= 1;
				check();
			};
		}

		function error(name) {
			return (...rest) => {
				errors[name] = {...rest};
				requests -= 1;
				check();
			};
		}

		function request(name, fn) {
			requests += 1;
			fn(success(name), error(name))();
		}

		request('years', (success, error) => fetchYears({make, model}, success, error));
		request('makes', (success, error) => fetchMakes({year, model}, success, error));
		request('models', (success, error) => fetchModels({make, year}, success, error));
		check();
	});
};

const updateDropdownElement = ($el, options=[], value='') => {
	const allOptionContent = $el.find('option[value=""]').html();
	const optionsHtml = [];

	function makeOption(id, value, selected=false) {
		const selContent = (selected) ? 'selected' : '';
		return `<option value="${id}" ${selContent}>${value}</option>`;
	}

	optionsHtml.push(makeOption('', allOptionContent));

	$el.empty();

	options.forEach((option) => {
		if (option.id === '') {
			// This "push to front" thing was copied from previous logic... unsure if needed
			optionsHtml.unshift(makeOption(option.id, option.label, option.selected));
		} else {
			optionsHtml.push(makeOption(option.id, option.label, option.selected));
		}
	});

	$el.append(optionsHtml.join(''));

	if (value) {
		$el.val(value);
	} else if (options.length === 1) {
		$el.val(options[0].id);
	}
};

const getDropdownContentFromData = (data={}) => {
	return Object.values(data).map((item={}) => {
		return {
			id: item.url || item.id,
			label: item.ui || item.label,
			selected: item.selected || false,
		};
	});
};

module.exports = {
	fetchYears,
	fetchMakes,
	fetchModels,
	fetchYmmFilters,
	updateDropdownElement,
	getDropdownContentFromData,
};
